import PropTypes from 'prop-types'
import { usePortal } from '@web-ui-kit/hooks.use-portal'
import Icon from '@web-ui-kit/icon'
import * as Sc from './BannerHeader.style'
import useMediaQuery from 'hooks/useMediaQuery'

const BannerHeader = ({ children, closeBanner, id, isOpen }) => {
  const { render } = usePortal(id)
  const { isDesktop } = useMediaQuery()

  if (!isOpen) return null

  const handleCloseBanner = () => {
    closeBanner()
  }

  return render(
    <Sc.Container $isSmall={!isDesktop}>
      <div>{children}</div>
      {handleCloseBanner && (
        <Sc.Close data-testid='close-banner' onClick={handleCloseBanner}>
          <Icon height={40} icon='close' width={40} />
        </Sc.Close>
      )}
    </Sc.Container>
  )
}

BannerHeader.defaultProps = {
  closeBanner: null,
  isOpen: false,
}

BannerHeader.propTypes = {
  children: PropTypes.node.isRequired,
  closeBanner: PropTypes.func,
  id: PropTypes.string.isRequired,
  isOpen: PropTypes.bool,
}

export default BannerHeader
